import React from 'react'
import { Card, Button } from 'react-bootstrap'
import styled from 'styled-components'
import axios from 'axios'
import config from '../../config'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'
import { useDispatch } from 'react-redux'

const OpenBox = () => {
  const dispatch = useDispatch()

  const handleOpenGiftBox = async () => {
    Swal.fire({
      title: `คุณต้องการจะเปิดกล่องของขวัญทั้งหมดในระบบใช่หรือไม่?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: `${Colors.SOFT_BLUE}`,
      cancelButtonColor: `${Colors.LIGHT_RED}`,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch({ type: 'loading_show' })
        try {
          const response = await axios.post(
            `${config.apiAdminGateway}/api/v3/admin/orders/gifts/open`,
            {},
            {
              headers: {
                Authorization: `Bearer ${Cookies.get('accessToken')}`,
              },
            },
          )

          if (response.data.status.code === 0) {
            Swal.fire({
              icon: 'success',
              title: 'เปิดของขวัญสำเร็จ',
              showConfirmButton: false,
              timer: 3000,
            })
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'ไม่สามารถเปิดกล่องของขวัญทั้งหมดได้',
            })
          }
          dispatch({ type: 'loading_hide' })
        } catch (error) {
          alert('ไม่สามารถเปิดกล่องของขวัญทั้งหมดได้')
        }
      }
    })
  }
  const handleOpenMysteryBox = async () => {
    Swal.fire({
      title: `คุณต้องการจะเปิดกล่องสุ่มทั้งหมดในระบบใช่หรือไม่?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: `${Colors.SOFT_BLUE}`,
      cancelButtonColor: `${Colors.LIGHT_RED}`,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch({ type: 'loading_show' })
        try {
          const response = await axios.post(
            `${config.apiAdminGateway}/api/v1/admin/mysteryboxes/open`,
            {},
            {
              headers: {
                Authorization: `Bearer ${Cookies.get('accessToken')}`,
              },
            },
          )
          if (response.data.status.code === 0) {
            Swal.fire({
              icon: 'success',
              title: 'เปิดของกล่องสุ่มสำเร็จ',
              showConfirmButton: false,
              timer: 3000,
            })
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'ไม่สามารถเปิดกล่องสุ่มทั้งหมดได้',
            })
          }
          dispatch({ type: 'loading_hide' })
        } catch (error) {
          alert('ไม่สามารถเปิดกล่องสุ่มทั้งหมดได้')
        }
      }
    })
  }
  const handleMatchPreOrderLottery = async () => {
    Swal.fire({
      title: `คุณต้องการจะจับชุดลอตเตอรี่ทั้งในระบบใช่หรือไม่?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: `${Colors.SOFT_BLUE}`,
      cancelButtonColor: `${Colors.LIGHT_RED}`,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch({ type: 'loading_show' })
        try {
          const response = await axios.post(
            `${config.apiAdminGateway}/api/v1/admin/preorder/process`,
            {},
            {
              headers: {
                Authorization: `Bearer ${Cookies.get('accessToken')}`,
              },
            },
          )
          if (response.data.status.code === 0) {
            Swal.fire({
              icon: 'success',
              title: 'จับชุดลอตเตอรี่สำเร็จ',
              showConfirmButton: false,
              timer: 3000,
            })
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'ไม่สามารถจับชุดลอตเตอรี่ทั้งหมดได้',
            })
          }
        } catch (error) {
          alert('ไม่สามารถจับชุดลอตเตอรี่ทั้งหมดได้')
        } finally {
          dispatch({ type: 'loading_hide' })
        }
      }
    })
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>เปิดกล่องทั้งหมด</Card.Title>
      </Card.Header>
      <Card.Body>
        <ButtonContainer>
          <span>เปิดกล่องสุ่มทั้งหมด</span>
          <Button variant="primary light" className="w-50 my-2" onClick={handleOpenMysteryBox}>
            เปิดกล่องสุ่ม
          </Button>
        </ButtonContainer>
        <ButtonContainer>
          <span>เปิดกล่องของขวัญทั้งหมด</span>
          <Button variant="primary light" className="w-50 my-2" onClick={handleOpenGiftBox}>
            เปิดกล่องของขวัญ
          </Button>
        </ButtonContainer>
        <ButtonContainer>
          <span>จับชุดจองลอตเตอรี่ทั้งหมด</span>
          <Button variant="primary light" className="w-50 my-2" onClick={handleMatchPreOrderLottery}>
            จับชุดจองลอตเตอรี่ทั้งหมด
          </Button>
        </ButtonContainer>
      </Card.Body>
    </Card>
  )
}
export default OpenBox

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
